import { UUICheckboxTheme } from '../../../types/UUICheckbox'

const checkboxTheme: UUICheckboxTheme = {
  element: ({ style = 'filled', size = 'normal', variant = 'normal', checked }) => {
    const disabled = 'disabled' === variant
    const invalid = 'invalid' === variant

    const baseClassName = `tw:flex tw:items-center tw:select-none ${
      'small' === size ? 'tw:w-3.5 tw:h-3.5' : 'tw:w-4 tw:h-4'
    } tw:rounded-sm tw:border ${disabled ? '' : 'tw:cursor-pointer'}`

    const checkboxClassNames = [baseClassName]
    if (disabled) {
      checkboxClassNames.push(
        checked || null === checked
          ? 'outline' === style
            ? // disabled | outline | checked
              'tw:disabled:border-grey-700 tw:disabled:bg-grey-800 tw:shadow-none'
            : // disabled | filled | checked
              'tw:disabled:border-grey-600 tw:disabled:bg-grey-600 tw:shadow-none'
          : // disabled | unchecked
            'tw:disabled:border-grey-700 tw:disabled:bg-grey-800 tw:shadow-none'
      )
      checkboxClassNames.push(
        'outline' === style
          ? // indicator | disabled | outline
            'tw:[&_path.UUICheckboxCheckIndicator-path]:fill-grey-600'
          : // indicator | disabled | filled
            'tw:[&_path.UUICheckboxCheckIndicator-path]:fill-grey-700'
      )
    } else if (invalid) {
      checkboxClassNames.push(
        checked || null === checked
          ? 'outline' === style
            ? // invalid | outline | checked
              'tw:border-red-50 tw:bg-transparent tw:shadow-none'
            : // invalid | filled | checked
              'tw:border-red-50 tw:bg-red-50 tw:shadow-none'
          : // invalid | unchecked
            'tw:border-red-50 tw:bg-transparent tw:shadow-none',
        checked || null === checked
          ? 'outline' === style
            ? // invalid | hover | outline | checked
              'tw:hover:border-red-100 tw:hover:bg-transparent tw:hover:shadow-none'
            : // invalid | hover | filled | checked
              'tw:hover:border-red-100 tw:hover:bg-red-100 tw:hover:shadow-none'
          : // invalid | hover | unchecked
            'tw:hover:border-red-100 tw:hover:bg-transparent tw:hover:shadow-none',
        checked || null === checked
          ? 'outline' === style
            ? // invalid | focus-visible | outline | checked
              'tw:focus-visible:border-red-50 tw:focus-visible:bg-transparent tw:focus-visible:shadow-[0_0_0_2px_rgba(226,41,78,0.35)]'
            : // invalid | focus-visible | filled | checked
              'tw:focus-visible:border-red-50 tw:focus-visible:bg-red-50 tw:focus-visible:shadow-[0_0_0_2px_rgba(226,41,78,0.35)]'
          : // invalid | focus-visible | unchecked
            'tw:focus-visible:border-red-50 tw:focus-visible:bg-transparent tw:focus-visible:shadow-[0_0_0_2px_rgba(226,41,78,0.35)]',
        checked || null === checked
          ? 'outline' === style
            ? // invalid | focus-visible:hover | outline | checked
              'tw:focus-visible:hover:border-red-100 tw:focus-visible:hover:bg-transparent tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(186,10,38,0.35)]'
            : // invalid | focus-visible:hover | filled | checked
              'tw:focus-visible:hover:border-red-100 tw:focus-visible:hover:bg-red-100 tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(186,10,38,0.35)]'
          : // invalid | focus-visible:hover | unchecked
            'tw:focus-visible:hover:border-red-100 tw:focus-visible:hover:bg-transparent tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(186,10,38,0.35)]'
      )
      checkboxClassNames.push(
        'outline' === style
          ? [
              // invalid | indicator | outline
              'tw:[&_path.UUICheckboxCheckIndicator-path]:fill-red-50',
              // invalid | indicator | hover | outline
              'tw:hover:[&_path.UUICheckboxCheckIndicator-path]:fill-red-100',
              // invalid | indicator | focus-visible | outline
              'tw:focus-visible:[&_path.UUICheckboxCheckIndicator-path]:fill-red-50',
              // invalid | indicator | focus-visible:hover | outline
              'tw:focus-visible:hover:[&_path.UUICheckboxCheckIndicator-path]:fill-red-100'
            ].join(' ')
          : // invalid | indicator | filled
            'tw:[&_path.UUICheckboxCheckIndicator-path]:fill-grey-1000'
      )
    } else {
      checkboxClassNames.push(
        checked || null === checked
          ? 'outline' === style
            ? // outline | checked
              'tw:border-grey-500 tw:bg-transparent tw:shadow-none'
            : // filled | checked
              'tw:border-blue-100 tw:bg-blue-100 tw:shadow-none'
          : // unchecked
            'tw:border-grey-500 tw:bg-transparent tw:shadow-none',
        checked || null === checked
          ? 'outline' === style
            ? // hover | outline | checked
              'tw:hover:border-aquamarine-400 tw:hover:bg-transparent tw:hover:shadow-none'
            : // hover | filled | checked
              'tw:hover:border-aquamarine-400 tw:hover:bg-aquamarine-400 tw:hover:shadow-none'
          : // hover | unchecked
            'tw:hover:border-aquamarine-400 tw:hover:bg-transparent tw:hover:shadow-none',
        checked || null === checked
          ? 'outline' === style
            ? // focus-visible | outline | checked
              'tw:focus-visible:border-blue-100 tw:focus-visible:bg-transparent tw:focus-visible:shadow-[0_0_0_2px_rgba(41,171,226,0.35)]'
            : // focus-visible | filled | checked
              'tw:focus-visible:border-blue-100 tw:focus-visible:bg-blue-100 tw:focus-visible:shadow-[0_0_0_2px_rgba(41,171,226,0.35)]'
          : // focus-visible | unchecked
            'tw:focus-visible:border-blue-100 tw:focus-visible:bg-transparent tw:focus-visible:shadow-[0_0_0_2px_rgba(41,171,226,0.35)]',
        checked || null === checked
          ? 'outline' === style
            ? // focus-visible:hover | outline | checked
              'tw:focus-visible:hover:border-aquamarine-400 tw:focus-visible:hover:bg-transparent tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(91,191,192,0.35)]'
            : // focus-visible:hover | filled | checked
              'tw:focus-visible:hover:border-aquamarine-400 tw:focus-visible:hover:bg-aquamarine-400 tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(91,191,192,0.35)]'
          : // focus-visible:hover | unchecked
            'tw:focus-visible:hover:border-aquamarine-400 tw:focus-visible:hover:bg-transparent tw:focus-visible:hover:shadow-[0_0_0_2px_rgba(91,191,192,0.35)]'
      )
      checkboxClassNames.push(
        'outline' === style
          ? [
              // indicator | outline
              'tw:[&_path.UUICheckboxCheckIndicator-path]:fill-grey-600',
              // indicator | hover | outline
              'tw:hover:[&_path.UUICheckboxCheckIndicator-path]:fill-aquamarine-200',
              // indicator | focus-visible | outline
              'tw:focus-visible:[&_path.UUICheckboxCheckIndicator-path]:fill-blue-100',
              // indicator | focus-visible:hover | outline
              'tw:focus-visible:hover:[&_path.UUICheckboxCheckIndicator-path]:fill-aquamarine-200'
            ].join(' ')
          : // indicator | filled
            'tw:[&_path.UUICheckboxCheckIndicator-path]:fill-grey-1000'
      )
    }
    return checkboxClassNames.join(' ')
  },
  label: ({ /* style = 'filled', */ size = 'normal' /*, variant = 'normal', checked */ }) =>
    'small' === size
      ? 'tw:flex-1 tw:text-xs tw:font-ubuntu tw:leading-[14px] tw:ml-1'
      : 'tw:flex-1 tw:text-sm tw:font-ubuntu tw:leading-4 tw:ml-2',
  indicator: (/*{ style = 'filled', size = 'normal', variant = 'normal', checked }*/) =>
    'tw:flex tw:items-center tw:justify-center tw:w-full tw:h-full'
}
export default checkboxTheme
